import React from 'react';
import {connect} from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import HighlightOnInAppMessage from '../inAppMessages/HighlightOninAppMessage';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import LIVE_REPORTING_CONTROLLER from '../../controllers/liveReporting';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';

const FORM_NAME = 'LEGAL_ENTITY_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

export class LegalEntityForm extends React.Component {

  constructor(props) {
    super(props);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.onFieldChangeHandlerFactory = this.onFieldChangeHandlerFactory.bind(this);
  }

  onLegalEntityAdd(fieldValues) {
    log.debug('onLegalEntityAdd() ');
    
  }

  onSubmitForm(event) {
    log.debug('onSubmitForm(): ', this.props.formData);
    if (!this.props.formData || typeof this.props.formData.fieldValues !== 'object') {
        return; 
    }
    let isInvalidForm = false;
    //Perform validations
    const taxNumber = this.props.formData.fieldValues.taxNumber;
    if(!taxNumber || taxNumber.trim() === '')
    {
        log.setDictionaryMessage(ALL_MESSAGES.BLANK_TAX_NUMBER);
        isInvalidForm = true;
    } 
    else if(taxNumber && taxNumber.length > 8)
    {
        log.setDictionaryMessage(ALL_MESSAGES.INVALID_TAX_NUMBER);
        isInvalidForm = true;
    }    

    const login = this.props.formData.fieldValues.login;
    if(!login || login.trim() === '')
    {
        log.setDictionaryMessage(ALL_MESSAGES.BLANK_LOGIN);
        isInvalidForm = true;
    }
    const password = this.props.formData.fieldValues.password;
    if(!password || password.trim() === '')
    {
        log.setDictionaryMessage(ALL_MESSAGES.BLANK_PASSWORD);
        isInvalidForm = true;
    }
    const xmlSignatureKey = this.props.formData.fieldValues.xmlSignatureKey;
    if(!xmlSignatureKey || xmlSignatureKey.trim() === '')
    {
        log.setDictionaryMessage(ALL_MESSAGES.BLANK_XML_SIGNATURE_KEY);
        isInvalidForm = true;
    }
    const xmlExchangeKey = this.props.formData.fieldValues.xmlExchangeKey;
    if(!xmlExchangeKey || xmlExchangeKey.trim() === '')
    {
        log.setDictionaryMessage(ALL_MESSAGES.BLANK_XML_EXCHANGE_KEY);
        isInvalidForm = true;
    }

    if(isInvalidForm) {
      return;
    }

    this.props.doAddLegalEntity(this.props.formData.fieldValues, () => {
      if(typeof this.props.onAddDone === 'function') {
        this.props.onAddDone(this.props.formData.fieldValues);
        this.onResetForm();
      }
    });

    // Let the forms controller know that the form has been submitted.
    this.props.doFormSubmitted(this.props.FORM_NAME_FOR_USER);   
    
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.props.doInitialiseForm(this.props.FORM_NAME_FOR_USER, this.props.legalEntity);
  }

  componentWillUnmount() {
    this.props.doDestroyForm(this.props.FORM_NAME_FOR_USER);
  }

  onFieldChangeHandlerFactory(fieldName) {
    return (evt) => {
        this.props.onFieldChange(this.props.FORM_NAME_FOR_USER, fieldName, evt.target.value);
    };
  }

  onResetForm() {
    log.debug('onResetForm(): ');
    this.props.doResetForm(this.props.FORM_NAME_FOR_USER);
  }

  onClearForm() {
      log.debug('onClearForm(): ');
      this.props.doClearForm(this.props.FORM_NAME_FOR_USER);
  }

  render() {
    log.debug('render(): ', this.props);
    const fieldValues = this.props.formData && this.props.formData.fieldValues;
    if (!fieldValues) {
        return (<div><LanguageStringResolver string="WaitingForFormToLoad"/></div>);
    }
    return (
        <s-box name="form-panel">
          <fieldset>
            <ApplicationMessages scopes={[FORM_NAME]} messageType="applicationError"/>
            <HighlightOnInAppMessage
              scopes={[FORM_NAME]}
              messageIds={[ALL_MESSAGES.BLANK_TAX_NUMBER, ALL_MESSAGES.INVALID_TAX_NUMBER]}>
              <label className="mt10"><LanguageStringResolver string="liveReportingSetup_TaxNumber"></LanguageStringResolver></label>
              <input type="text"  value={fieldValues.taxNumber} onChange={this.onFieldChangeHandlerFactory('taxNumber')}/>
            </HighlightOnInAppMessage>  

            <HighlightOnInAppMessage
              scopes={[FORM_NAME]}
              messageIds={[]} >
              <label className="mt10"><LanguageStringResolver string="liveReportingSetup_SupplierName"></LanguageStringResolver></label>
              <input type="text"  value={fieldValues.sellerName} onChange={this.onFieldChangeHandlerFactory('sellerName')}/>
            </HighlightOnInAppMessage>

            <HighlightOnInAppMessage
              scopes={[FORM_NAME]}
              messageIds={[ALL_MESSAGES.BLANK_LOGIN]} >
              <label className="mt10"><LanguageStringResolver string="liveReportingSetup_Login"></LanguageStringResolver></label>
              <input type="text"  value={fieldValues.login} onChange={this.onFieldChangeHandlerFactory('login')}/>
            </HighlightOnInAppMessage>    

            <HighlightOnInAppMessage
              scopes={[FORM_NAME]}
              messageIds={[ALL_MESSAGES.BLANK_PASSWORD]} >
              <label className="mt10"><LanguageStringResolver string="liveReportingSetup_Password"></LanguageStringResolver></label>
              <input className={withFullStoryExclude()} type="password" value={fieldValues.password} onChange={this.onFieldChangeHandlerFactory('password')}/>
            </HighlightOnInAppMessage>  

            <HighlightOnInAppMessage
              scopes={[FORM_NAME]}
              messageIds={[ALL_MESSAGES.BLANK_XML_SIGNATURE_KEY]} >
              <label className="mt10"><LanguageStringResolver string="liveReportingSetup_XMLSignatureKey"></LanguageStringResolver></label>
              <input className={withFullStoryExclude()} type="password"  value={fieldValues.xmlSignatureKey} onChange={this.onFieldChangeHandlerFactory('xmlSignatureKey')}/>
            </HighlightOnInAppMessage>  

            <HighlightOnInAppMessage
              scopes={[FORM_NAME]}
              messageIds={[ALL_MESSAGES.BLANK_XML_EXCHANGE_KEY]} >
              <label className="mt10"><LanguageStringResolver string="liveReportingSetup_XMLExchangeKey"></LanguageStringResolver></label>
              <input className={withFullStoryExclude()} type="password"  value={fieldValues.xmlExchangeKey} onChange={this.onFieldChangeHandlerFactory('xmlExchangeKey')}/>
            </HighlightOnInAppMessage>  

            <span className="clear"></span>
            <button className="primary mt10" onClick={this.onSubmitForm}>
              <LanguageStringResolver string="liveReportingSetup_Save"></LanguageStringResolver>
            </button>
          </fieldset>
        </s-box>
    )
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps: ', state);  
  const formNameForUser = FORM_NAME+'_FOR_'+ (props.user !== undefined ? props.user.email : 'LoggedOut');
  return {
    languages: state.languages,
    formData: (state.managedUxForms && state.managedUxForms.forms[formNameForUser]),
    FORM_NAME_FOR_USER: formNameForUser,
  };
}

function mapDispatchersToProps(dispatch) {
  return {
      doInitialiseForm: (formNameForUser,initialValues) => {
          dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(formNameForUser, initialValues));
      },
      doResetForm: (formNameForUser) => {
          dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(formNameForUser));
      },
      doClearForm: (formNameForUser) => {
          dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(formNameForUser));
      },
      onFieldChange: (formNameForUser, fieldName, value) => {
          dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(formNameForUser, fieldName, value));
      },
      doFormSubmitted: (formNameForUser) => {
          dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(formNameForUser));
      },
      doDestroyForm: (formNameForUser) => {
          dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(formNameForUser));
      },
      doAddLegalEntity: (params, done) => {
        log.debug('doAddLegalEntity: ', params);
        dispatch(LIVE_REPORTING_CONTROLLER.doAddLegalEntity(params, done));
    }
  }
}


LegalEntityForm.defaultProps = {
  onAddDone: () => {},
  legalEntity: {}
}

export default connect(mapStateToProps, mapDispatchersToProps)(LegalEntityForm);